<script setup lang="ts">
import type { MessageContent } from "ls/api/cloud/ai";
import MarkdownItNode from "./MarkdownItNode.vue";

defineProps<{
  content: MessageContent[];
  incomingMessageContent?: MessageContent;
  proseVariant?: "none" | "default" | "small";
}>();
</script>

<template>
  <div
    v-if="incomingMessageContent || (content?.length && content[0].markdown && content[0].markdown.children.length > 0)"
    :class="{ 'prose': proseVariant === 'default', 'prose-sm': proseVariant === 'small' }"
    class="max-w-full flex-1 p-2 leading-relaxed [&>p:not(:first-of-type)]:mt-4"
  >
    <template v-for="line in content" :key="line.index">
      <MarkdownItNode :node="line.markdown" />
    </template>
    <MarkdownItNode v-if="incomingMessageContent" :node="incomingMessageContent.markdown" />
  </div>
</template>

<style scoped>
.prose-sm ul {
  list-style-type: inherit;
}
.prose-sm ol {
  list-style-type: auto;
}
</style>
